import { useState } from "react";
import {
    Box,
    Button,
    Backdrop,
    IconButton,
    Tooltip,
    Snackbar,
    Alert,
    TextField,
    Stack
} from "@mui/material";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

import CustomButton from "../custom_components/CustomButton";
import CustomModalHeader from "../custom_components/CustomModalHeader";

const apiUrl = process.env.REACT_APP_API_URL;

export default function PaymentSummaryQR({ open, onClose, qrImage, imageUrl }) {

    const [copied, setCopied] = useState(false);
    const [error, setError] = useState(false);

    const handleCopyUrl = async () => {
        try {
            await navigator.clipboard.writeText(imageUrl);
            setCopied(true);
        } catch {
            setError(true);
        }
    };

    return (
        <Backdrop
            aria-hidden="false"
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backdropFilter: "blur(1px)",
            }}
        >
            {/* PAPER POPUP */}
            <Box
                sx={{
                    width: "40%",
                    backgroundColor: "#ffffff",
                    borderRadius: 2,
                    p: 2.5,
                    boxShadow: 6,

                    position: "relative",
                    overflow: "hidden",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "4px",
                        background: "#2e3489"
                    }
                }}
            >
                {/* HEADER */}
                <CustomModalHeader
                    title="Total Sold Items QR Code"
                    subtitle="Scan this QR code using your mobile phone camera."
                    onClose={onClose}
                />

                {qrImage && (
                    <Box
                        component="img"
                        src={qrImage}
                        alt="Payment Summary QR Code"
                        sx={{
                            width: 300,
                            maxWidth: "100%",
                            height: "auto",
                            display: "block",
                            mx: "auto",
                        }}
                    />
                )}

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        width: "100%",
                    }}
                >
                    <TextField
                        fullWidth
                        size="small"
                        label="Image URL"
                        value={imageUrl || ""}
                        slotProps={{
                            input: {
                                readOnly: true,
                            },
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 1,
                                color: "#94A3B8"
                            },
                        }}
                    />

                    <Tooltip title={copied ? "Copied!" : "Copy URL"}>
                        <IconButton
                            onClick={handleCopyUrl}
                            disabled={!imageUrl}
                            color={copied ? "success" : "primary"}
                            sx={{
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 1,
                                width: 42,
                                height: 42,
                            }}
                        >
                            {copied ? <CheckIcon /> : <ContentCopyIcon />}
                        </IconButton>
                    </Tooltip>
                </Box>

                <Stack sx={{ mt: 2 }}></Stack>

                {/* CLOSE BUTTON */}
                <CustomButton
                    label="Close"
                    variant="outlined"
                    hoverColor="#d14249"
                    onClick={onClose}
                />

                {/* ALERTS */}
                <Snackbar
                    open={copied}
                    autoHideDuration={2000}
                    onClose={() => setCopied(false)}
                >
                    <Alert severity="success" variant="filled">
                        URL copied to clipboard!
                    </Alert>
                </Snackbar>

                <Snackbar
                    open={error}
                    autoHideDuration={3000}
                    onClose={() => setError(false)}
                >
                    <Alert severity="error" variant="filled">
                        Unable to copy URL.
                    </Alert>
                </Snackbar>
            </Box>

        </Backdrop>
    );
}
